import { combineReducers, configureStore } from "@reduxjs/toolkit"
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux"
import { RESET_STATE_ACTION_TYPE } from "./actions/reset"
import { authReducer, authSlice } from "./slices/auth/auth"
import { breadcrumbReducer, breadcrumbSlice } from "./slices/breadcrumbs-slice"
import baseApi from "src/api/base-api"
// import { alertReducer, alertSlice } from "./slices/alert"

const reducers = { 
  [authSlice.name]: authReducer, 
  [breadcrumbSlice.name]: breadcrumbReducer,
  [baseApi.reducerPath]: baseApi.reducer 
}

const combinedReducer = combineReducers<typeof reducers>(reducers)

export const rootReducer = (state: any, action: any) => {
  if (action.type === RESET_STATE_ACTION_TYPE) {
    state = {} as RootState
  }

  return combinedReducer(state, action)
}

// React 19: Enhanced store configuration with better performance
export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // React 19: Optimized for concurrent features
      serializableCheck: { ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"] },
      // Better performance with React 19
      immutableCheck: { warnAfter: 128 }
    }).concat(baseApi.middleware),
  // React 19: Enhanced DevTools integration
  devTools: process.env.NODE_ENV !== "production" && { trace: true, traceLimit: 25 }
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof combinedReducer>

// React 19: Optimized typed hooks with better performance
export const useTypedDispatch = (): AppDispatch => useDispatch<AppDispatch>()
export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector
